<template>
  <PopoverPrompt
    v-model="showDialog"
    :icon="icon"
    :title="$t('components.prompt.promptEntityDelete.title')"
    :error="error"
    type="error"
    :submit-action="del"
    :submit-enabled="submitEnabled && !$slots.error"
    :submit-label="$t('global.button.delete')"
    submit-color="error"
    :submit-icon="icon"
    cancel-icon=""
    :cancel-action="close"
    v-bind="$attrs"
  >
    <template #activator="{ props }">
      <slot name="activator" v-bind="{ props }">
        <ButtonDelete v-bind="{ ...props, ...btnAttrs }" />
      </slot>
    </template>
    <slot>
      <p>
        {{
          $t(
            'global.warning.delete',
            { entity: warningTextEntity },
            warningTextEntity ? 2 : 0
          )
        }}
      </p>
    </slot>
    <template v-if="$slots.error || error" #error>
      <slot name="error">
        {{ error }}
      </slot>
    </template>
  </PopoverPrompt>
</template>

<script>
import DialogBase from '../dialog/DialogBase.vue'
import PopoverPrompt from '@/components/prompt/PopoverPrompt.vue'
import ButtonDelete from '@/components/buttons/ButtonDelete.vue'

export default {
  name: 'PromptEntityDelete',
  components: { ButtonDelete, PopoverPrompt },
  extends: DialogBase,
  props: {
    entity: { type: [Object, String], required: true },
    submitEnabled: { type: Boolean, required: false, default: true },
    icon: { type: String, required: false, default: 'mdi-delete' },
    warningTextEntity: { type: String, required: false, default: '' },
    btnAttrs: { type: Object, required: false, default: () => {} },
  },
  created() {
    this.entityUri =
      typeof this.entity === 'string' ? this.entity : this.entity._meta.self
  },
}
</script>

<style scoped></style>
